import type {Weekday} from "@/shared/constants";
import type {FixedBreak} from "@/shared/timr";
import type {FixedBreakType} from "@/shared/timrTypes";

export type FixedBreakField = keyof FixedBreak;
export type FixedBreakKey = "fixedBreak" | `fixedBreak${Weekday}`;

export const EMPTY_FIXED_BREAK: FixedBreak = {from1: null, to1: null, from2: null, to2: null, from3: null, to3: null};

export const FIXED_BREAK_FIELDS: [FixedBreakField, FixedBreakField][] = [
	["from1", "to1"],
	["from2", "to2"],
	["from3", "to3"]
];

export const FIXED_BREAK_KEYS: FixedBreakKey[] = [
	"fixedBreak",
	"fixedBreakMonday",
	"fixedBreakTuesday",
	"fixedBreakWednesday",
	"fixedBreakThursday",
	"fixedBreakFriday",
	"fixedBreakSaturday",
	"fixedBreakSunday"
];

const FIXED_BREAK_FIELD_NAMES: FixedBreakField[] = ["from1", "to1", "from2", "to2", "from3", "to3"];

export interface FixedBreakConfiguration {
	fixedBreakType: FixedBreakType;
	fixedBreak: FixedBreak;
	fixedBreakMonday: FixedBreak;
	fixedBreakTuesday: FixedBreak;
	fixedBreakWednesday: FixedBreak;
	fixedBreakThursday: FixedBreak;
	fixedBreakFriday: FixedBreak;
	fixedBreakSaturday: FixedBreak;
	fixedBreakSunday: FixedBreak;
}

export function fixedBreakConfigurationsEqual(first: FixedBreakConfiguration, second: FixedBreakConfiguration): boolean {
	return first.fixedBreakType === second.fixedBreakType
		&& FIXED_BREAK_KEYS.every(key => fixedBreaksEqual(first[key], second[key]));
}

export function hasFixedBreakRangeError(errorFields: Set<string>, fixedBreakKey: FixedBreakKey, fromField: FixedBreakField, toField: FixedBreakField): boolean {
	return errorFields.has(`${fixedBreakKey}.${fromField}`) || errorFields.has(`${fixedBreakKey}.${toField}`);
}

function fixedBreaksEqual(first: FixedBreak | null | undefined, second: FixedBreak | null | undefined): boolean {
	return FIXED_BREAK_FIELD_NAMES.every(field => first?.[field] === second?.[field]);
}
